import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationDataProvider } from './configuration-data-provider';
import { SharedDataProvider } from './shared-data-provider';
import { MenuItem } from './dto/menu-item';
import { Module } from './dto/module';

/*
  Generated class for the ModuleProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ModuleProvider {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private http: HttpClient, private config: ConfigurationDataProvider, private shared: SharedDataProvider) { }


  public getEnabledModules(): any {
    return this.http.post(this.config.moduleURL + "allowed/mobile", JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
  }

  /**
   * Loads all enabled modules into shared data
   */
  public loadEnabledModules(): any {
    this.http.post(this.config.moduleURL + "allowed/mobile", JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers })
      .subscribe(
        (modList : any) => {
          let menuItems: MenuItem[] = [];
          for (var mod of modList) {
            let item: MenuItem = new MenuItem();
            item.name = mod.name;
            item.link = mod.link;
            menuItems.push(item);
          }
          this.shared.setMainMenuItems(menuItems);
        }
      );
  }

  /**
   * Loads all enabled modules into shared data
   */

  public saveModuleListActiveState(pModules: Module[]): any {
    console.log('Push article to insert method of service.');
    var params: any = {};
    params.credentials = this.shared.getTokenAuthData();
    params.list = pModules;
    console.log(JSON.stringify(params));
    return this.http.post(this.config.moduleURL + "list/activestate", JSON.stringify(params), { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// ./src/providers/module-provider.ts